/*eslint-env jquery*/
import React, { Component } from 'react'
import moment from 'moment-jalaali' // Notice here !
import MaskedInput from 'react-text-mask'
import { Popup } from 'semantic-ui-react'

moment.loadPersian({
  dialect: "persian-modern",
  usePersianDigits: false
});

class DateInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      _moment: moment(),
      defaultValue: this.props.defaultValue ? this.formatDefaultValue(this.props.defaultValue) : '',
      cleared: true,
      loading: true,
      error: false
      // value: this.props.defaultValue ?
      //   this.formatDefaultValue(this.props.defaultValue) : ''
    };


    // console.log(this.props.defaultValue)
  }

  //   async componentDidMount() {
  //     this.props.defaultValue &&
  //       await this.formatDefaultValue(this.props.defaultValue);
  //   }

  async componentWillReceiveProps(nextProps) {
    // console.log("here1")
    if (nextProps.defaultValue && moment(nextProps.defaultValue).isValid()) {
      // console.log("hecre2")
      await this.formatDefaultValue(nextProps.defaultValue);
    }
  }

  formatDefaultValue = async (e) => {
    if (e !== '0001-01-01T00:00:00') {
      let m = moment(e.split("T")[0], 'YYYY-MM-DD');
      const momentValue = moment(e.split("T")[0], 'YYYY-MM-DD');
      if (momentValue.isValid()) {
        await this.setState({ inputValue: momentValue.format("jYYYY/jMM/jDD"), _moment: m, loading: false, cleared: false });
      }
    }
  }

  formatDefaultValue = async (e) => {
    if (e !== '0001-01-01T00:00:00') {
      let m = moment(e.split("T")[0], 'YYYY-MM-DD');
      const momentValue = moment(e.split("T")[0], 'YYYY-MM-DD');
      if (momentValue.isValid()) {
        await this.setState({ inputValue: momentValue.format("jYYYY/jMM/jDD"), _moment: m, loading: false, cleared: false });
      }
    }
  }

  //   handleChange = (selectedMoment) => {
  //     const inputValue = selectedMoment;
  //     const momentValue = inputValue.format("jYYYY/jMM/jDD");

  //     this.setState({
  //       inputValue: momentValue,
  //       _moment: selectedMoment,
  //       cleared: false
  //     });

  //     const val = selectedMoment.format("YYYY-MM-DD");
  //     this.props.onChange(val);

  //     // if (moment(val, "YYYY-MM-DD").isValid()) {
  //     //   // console.log(val);
  //     //   this.dispatchEventChange(inputValue);
  //     // }

  //   }

  //   dispatchEventChange = (val) => {
  //     var element = this.node;
  //     var ev = new Event('input', { bubbles: true });
  //     ev.simulated = true;
  //     element.value = val;
  //     element.dispatchEvent(ev);

  //   }

  handleInputChange = (event) => {
    const inputValue = event.target.value;

    let regex = (/^[1][1-4][0-9]{2}\/((0[1-6]\/(0[1-9]|[1-2][0-9]|3[0-1]))|(0[7-9]\/(0[1-9]|[1-2][0-9]|30))|(1[0-1]\/(0[1-9]|[1-2][0-9]|30))|(12\/(0[1-9]|[1-2][0-9])))/.test(inputValue))

    // if (regex) {

    const momentValue = moment(inputValue, 'jYYYY-jMM-jDD');
    console.log(inputValue);

    this.setState({ cleared: true });

    if (inputValue.length === 10) {

      this.setState({ inputValue })

      if (regex && momentValue.isValid()) {
        this.setState({ inputValue, _moment: momentValue, cleared: false, error: false });

        const val = momentValue.format("YYYY-MM-DD");
        this.props.onChange(val);

        // console.log(inputValue);
        // this.dispatchEventChange(momentValue);

      } else {
        this.props.onChange('');
        this.setState({ error: true })
      }
    }


    // else {
    //   this.setState({ error: true })
    // }
  }


  render() {
    const { _moment, cleared, inputValue, error } = this.state;

    const { name, onChange, handleBlur, disabled, minDate, maxDate, tabIndex, className } = this.props;

    const newMoment = moment();


    // var value = !cleared && _moment ? _moment.format("jYYYY/jMM/jDD") : "";

    return (
      <div className="datepicker">

        <Popup
          content={error ? 'لطفا تاریخ تولد را صحیح وارد نمائید' : ''}
          className="datepicker-error-popup"
          // onClose={() => this.setState({ error: false })}

          open={error}
          trigger={
            <MaskedInput tabIndex={tabIndex} disabled={disabled} className={className + " date-input"} showMask={true} value={inputValue} onChange={this.handleInputChange} onBlur={handleBlur}
              mask={[/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/]} />
          }
        />

      </div>
    );
  }
}
export default DateInput;
